import { SendCMD } from "@/utils/HTTPRequest";
import { AppendKwaiClickId, SaveKwaiClickIdFromLocation } from "@/utils/KwaiClickId";

const KWAI_PIXEL_IDS_BY_CHANNEL = {
  zaikwai: "316602943875503",
};

const getStoredObject = (key) => {
  const value = localStorage.getItem(key);
  if (!value) {
    return {};
  }
  try {
    const parsed = JSON.parse(value);
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      return parsed;
    }
  } catch (e) {
    console.error(e);
  }
  return {};
};

export const LoadBgSettings = async (location, getPersist, setPersist) => {
  const query = new URLSearchParams(location && location.search ? location.search : window.location.search);
  const pathname = location && location.pathname ? location.pathname : window.location.pathname;
  let channel = query.get("c");
  if (!channel && pathname.startsWith("/c/")) {
    channel = pathname.substring(3);
  }
  if (getPersist("channel")) {
    channel = getPersist("channel");
  } else if (channel) {
    setPersist("channel", channel);
  }
  const kwaiClickId = SaveKwaiClickIdFromLocation(location, channel);

  const res = await SendCMD("bgSettings", AppendKwaiClickId({
    channel,
    guest_id: window.guestId ? window.guestId() : "",
    first_visit_url: localStorage.getItem("first_visit_url"),
    first_visit_time: localStorage.getItem("first_visit_time"),
  }, location, channel));
  console.log("bgSettings res", res);

  const channelInfo = res && res.settings && res.settings.channel_info;
  if (channelInfo && channelInfo.fb_id) {
    console.log("fb_pixel_id", channelInfo.fb_id);
    setPersist("fb_pixel_id", channelInfo.fb_id);
  }
  const kwaiPixelId = (channelInfo && (channelInfo.kwai_pixel_id || channelInfo.kwai_id)) || KWAI_PIXEL_IDS_BY_CHANNEL[channel];
  if (kwaiPixelId) {
    console.log("kwai_pixel_id", kwaiPixelId);
    localStorage.setItem("attribution", "kwai");
    localStorage.setItem("attribution_id", kwaiPixelId);
    if (kwaiClickId) {
      const oldAdSource = getStoredObject("ad_source");
      oldAdSource.kwai_click_id = kwaiClickId;
      localStorage.setItem("ad_source", JSON.stringify(oldAdSource));
    }
    setPersist("kwai_pixel_id", kwaiPixelId);
  }
  if (channelInfo && channelInfo.boomplay_id) {
    console.log("boomplay_id", channelInfo.boomplay_id);
    localStorage.setItem("attribution", "boomplay");
    localStorage.setItem("attribution_id", channelInfo.boomplay_id);
    const oldAdSource = getStoredObject("ad_source");
    oldAdSource.click_id = query.get("click_id") ? query.get("click_id") : oldAdSource.click_id;
    oldAdSource.click_time = query.get("click_time") ? query.get("click_time") : oldAdSource.click_time;
    oldAdSource.account_id = query.get("account_id") ? query.get("account_id") : oldAdSource.account_id;
    oldAdSource.data_source_id = query.get("data_source_id") ? query.get("data_source_id") : oldAdSource.data_source_id;
    oldAdSource.ip = query.get("ip") ? query.get("ip") : oldAdSource.ip;
    oldAdSource.user_agent = query.get("user_agent") ? query.get("user_agent") : oldAdSource.user_agent;
    oldAdSource.ad_id = query.get("ad_id") ? query.get("ad_id") : oldAdSource.ad_id;
    oldAdSource.callback_url = query.get("callback_url") ? query.get("callback_url") : oldAdSource.callback_url;
    localStorage.setItem("ad_source", JSON.stringify(oldAdSource));
    setPersist("boomplay_id", channelInfo.boomplay_id);
  }
  if (channelInfo && channelInfo.mgsky_id) {
    localStorage.setItem("attribution", "mgsky");
    localStorage.setItem("attribution_id", channelInfo.mgsky_id);
    const oldAdSource = getStoredObject("ad_source");
    oldAdSource.pixel_click_id = query.get("pixel_click_id") ? query.get("pixel_click_id") : oldAdSource.pixel_click_id;
    oldAdSource.pixel_id = query.get("pixel_id") ? query.get("pixel_id") : oldAdSource.pixel_id;
    oldAdSource.clickid = query.get("clickid") ? query.get("clickid") : oldAdSource.clickid;
    oldAdSource.gaid = query.get("gaid") ? query.get("gaid") : oldAdSource.gaid;
    oldAdSource.utm_source = query.get("utm_source") ? query.get("utm_source") : oldAdSource.utm_source;
    localStorage.setItem("ad_source", JSON.stringify(oldAdSource));
    setPersist("mgsky_id", channelInfo.mgsky_id);
  }
  if (channelInfo && channelInfo.okspin_id) {
    console.log("okspin_id", channelInfo.okspin_id);
    localStorage.setItem("attribution", "okspin");
    localStorage.setItem("attribution_id", channelInfo.okspin_id);
    setPersist("okspin_id", channelInfo.okspin_id);
  }
  if (res) {
    setPersist("bgSettings", res);
    if (res.abtest_tag) {
      setPersist("abtest_tag", res.abtest_tag);
    }
    if (res.client_show_time) {
      setPersist("client_show_time", res.client_show_time);
    }
    setPersist("recall_act_open", false);
    if (res.recall_act_open && res.recall_act_now && res.recall_act_end_time && res.recall_act_now < res.recall_act_end_time) {
      setPersist("recall_act_open", res.recall_act_open);
    }
  }
  return res;
};
